import React from 'react'

const Footer = () => {
    return (
        <footer className="footer">
            &copy; {new Date().getFullYear()} Juvasoft Soluciones S.C.
        </footer>
    )
}

export default Footer